<template>
  <div style="margin-top:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Manage Alerts Settings</span><br/>
    </div>

    <div v-if="!loading" style="text-align: left; color: #666;" class="d-flex align-items-center justify-content-center">
      <form @submit.prevent=" save_config">
        <table width="90%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
          <tr>
            <td width="500" align="right">Alerts Enabled</td>
            <td width="800"><b-form-select v-model="model.alerts_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="model.late_alert_enabled">
            <td width="500"align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px; width:500px;" v-on:click="toggle_div(toggle,'isLateAlertVisible')">&#8594; Late Alerts</span></td>
            <td width="800"><b-form-select v-model="model.late_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isLateAlertVisible">
            <tr>
              <td align="right" width="400">Filter Start Yard(s)</td>
              <td width="800">
                <template>
                <div align="bottom">
                  <span class="help-block">Alerts will send for all start locations if no yards are selected</span>
                  <br/>
                  <label v-for="option in yard_options" :key="option.value">
                  <input type="checkbox" :value="option.value" v-model="selectedYardOptions">
                    {{ option.text }}&nbsp;&nbsp;&nbsp;
                  </label>
                </div>
              </template>
              </td>
            </tr>
            <tr>
              <td align="right" width="400">Trigger Minutes After Planned Time</td>
              <td width="800"><b-form-input v-model="model.late_alert_minutes" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Alert Time Window</td>
              <td width="800"><b-form-input v-model="model.late_alert_time_window" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Send To Driver</td>
              <td width="800"><b-form-select v-model="model.late_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'TBN'">
              <td align="right" width="400">Trigger Using Driver Start Time</td>
              <td width="800"><b-form-select v-model="model.late_alert_driver_start_time_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'TBN'">
              <td align="right" width="400">Trigger Using First Departure Time</td>
              <td width="800"><b-form-select v-model="model.late_alert_first_departure_time_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Suppress If HOS Login Detected</td>
              <td width="800"><b-form-select v-model="model.late_alert_suppress_if_hos_login" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'TBN'">
              <td align="right" width="400">Suppress If HOS Assignment Detected</td>
              <td width="800"><b-form-select v-model="model.late_alert_suppress_if_hos_assigned" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Suppress If Pre Trip DVIR Created</td>
              <td width="800"><b-form-select v-model="model.late_alert_suppress_if_dvir_created" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Suppress If Vehicle Is Turned On</td>
              <td width="800"><b-form-select v-model="model.late_alert_suppress_if_vehicle_key_on" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Suppress If Vehicle Moves</td>
              <td width="800"><b-form-select v-model="model.late_alert_suppress_if_vehicle_speed" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Suppress If Vehicle Leaves Yard</td>
              <td width="800"><b-form-select v-model="model.late_alert_suppress_if_vehicle_left_yard" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'CM'">
              <td align="right" width="400">Private Hires Only</td>
              <td width="800"><b-form-select v-model="model.late_alert_private_hires_only" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Booking Type Filter</td>
              <td width="800"><b-form-input v-model="model.late_alert_booking_type_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Booking ID Filter</td>
              <td width="800"><b-form-input v-model="model.late_alert_booking_id_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Client ID Filter</td>
              <td width="800"><b-form-input v-model="model.late_alert_client_id_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Driver Tag Filter</td>
              <td width="800"><b-form-input v-model="model.late_alert_driver_tag_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Vehicle Tag Filter</td>
              <td width="800"><b-form-input v-model="model.late_alert_vehicle_tag_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Vehicle ID Filter</td>
              <td width="800"><b-form-input v-model="model.late_alert_vehicle_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Send By Booking Type</td>
              <td width="800"><b-form-input v-model="model.late_alert_by_booking_type" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Send By Booking Base</td>
              <td width="800"><b-form-textarea v-model="model.late_alert_by_booking_base" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Send By Company ID</td>
              <td width="800"><b-form-input v-model="model.late_alert_by_company_id" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="500">SMS Failure Recipients</td>
              <td width="800"><b-form-input v-model="model.late_alert_failed_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.late_alert_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Voice Recipients</td>
              <td width="800"><b-form-input v-model="model.late_alert_voice_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Voice Base Config</td>
              <td width="800"><b-form-textarea v-model="model.late_alert_voice_base_config" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Voice Message Text</td>
              <td width="800"><b-form-input v-model="model.late_alert_voice_message" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Voice Time Window</td>
              <td width="800"><b-form-input v-model="model.late_alert_voice_time_window" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.late_alert_sms" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'CM'">
              <td align="right" width="400">Contract Email Recipients</td>
              <td width="800"><b-form-input v-model="model.late_alert_email_contract" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'CM'">
              <td align="right" width="400">Private Hire Email Recipients</td>
              <td width="800"><b-form-input v-model="model.late_alert_email_private" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'CM'">
              <td align="right" width="400">Contract SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.late_alert_sms_contract" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'CM'">
              <td align="right" width="400">Private Hire SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.late_alert_sms_private" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Slack Channel URL</td>
              <td width="800"><b-form-input v-model="model.late_alert_slack_url" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">MS Teams Channel URL</td>
              <td width="800"><b-form-input v-model="model.late_alert_msteams_url" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="model.late_alert_sms_template">
              <td align="right" width="400">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.late_alert_sms_template" :rows="model.late_alert_sms_template.length / 20"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-else>
              <td align="right" width="400">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.late_alert_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          <tr>
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isVehicleLateAlertVisible')">&#8594; Advanced Late Alerts</span></td>
            <td width="800"><b-form-select v-model="model.vehicle_late_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isVehicleLateAlertVisible">
            <tr>
              <td align="right" width="400"></td>
              <td width="800"><b-button variant="" @click="manage_vehicle_late_events = !manage_vehicle_late_events">Manage Events</b-button></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          <tr>
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isVehActivityVisible')">&#8594; Vehicle Activity Alerts</span></td>
            <td width="800"><b-form-select v-model="model.eld_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isVehActivityVisible">
            <tr>
              <td align="right" width="400">Send To Driver</td>
              <td width="800"><b-form-select v-model="model.eld_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.eld_alert_idle_alert_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.eld_alert_idle_alert_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">ELD Fault Email Recipients</td>
              <td width="800"><b-form-input v-model="model.eld_alert_fault_alert_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">ELD Fault SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.eld_alert_fault_alert_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="model.eld_alert_idle_alert_sms_template">
              <td align="right" width="400">Idle Alert SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.eld_alert_idle_alert_sms_template" :rows="model.eld_alert_idle_alert_sms_template.length / 20"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-else>
              <td align="right" width="400">Idle Alert SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.eld_alert_idle_alert_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="model.eld_alert_idle_alert_sms_geofence_template">
              <td align="right" width="400">Idle / Geofence Alert SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.eld_alert_idle_alert_sms_geofence_template" :rows="model.eld_alert_idle_alert_sms_geofence_template / 20"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-else>
              <td align="right" width="400">Idle / Geofence Alert SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.eld_alert_idle_alert_sms_geofence_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="model.eld_alert_fault_alert_sms_template">
              <td align="right" width="400">ELD Fault SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.eld_alert_fault_alert_sms_template" :rows="model.eld_alert_fault_alert_sms_template / 20"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-else>
              <td align="right" width="400">ELD Fault SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.eld_alert_fault_alert_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">ELD Fault Description Mapping</td>
              <td width="800"><b-form-input v-model="model.eld_alert_fault_alert_mappings" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          <tr>
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isVehInactiveVisible')">&#8594; Vehicle Inactivity Alerts</span></td>
            <td width="800"><b-form-select v-model="model.vehicle_inactivity_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isVehInactiveVisible">
            <tr>
              <td align="right" width="400">Send To Driver</td>
              <td width="800"><b-form-select v-model="model.vehicle_inactivity_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.vehicle_inactivity_alert_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.vehicle_inactivity_alert_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Geofence</td>
              <td width="800"><b-form-input v-model="model.vehicle_inactivity_alert_geofence" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Vehicle Filter</td>
              <td width="800"><b-form-input v-model="model.vehicle_inactivity_alert_vehicle_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Vehicle Tag Filter</td>
              <td width="800"><b-form-input v-model="model.vehicle_inactivity_alert_vehicle_tag_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Active Time Window</td>
              <td width="800"><b-form-input v-model="model.vehicle_inactivity_alert_active_time_windows" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Duration Threshold</td>
              <td width="800"><b-form-input v-model="model.vehicle_inactivity_alert_duration_threshold" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Speed Threshold</td>
              <td width="800"><b-form-input v-model="model.vehicle_inactivity_alert_speed_threshold" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="model.vehicle_inactivity_alert_sms_template">
              <td align="right" width="400">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.vehicle_inactivity_alert_sms_template" :rows="model.vehicle_inactivity_alert_sms_template.length / 20"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-else>
              <td align="right" width="400">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.vehicle_inactivity_alert_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          <tr>
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isHOSDurationVisible')">&#8594; HOS Duration Alerts</span></td>
            <td width="800"><b-form-select v-model="model.driver_hos_alerts_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isHOSDurationVisible">
            <tr>
              <td align="right" width="400">Send To Driver</td>
              <td width="800"><b-form-select v-model="model.driver_hos_alerts_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.driver_hos_alerts_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.driver_hos_alerts_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="model.driver_hos_alerts_sms_template">
              <td align="right" width="400">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.driver_hos_alerts_sms_template" :rows="model.driver_hos_alerts_sms_template.length / 20"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-else>
              <td align="right" width="400">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.driver_hos_alerts_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400"></td>
              <td width="800"><b-button variant="" @click="manage_hos_events = !manage_hos_events">Manage Alert Events</b-button></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          <tr>
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isUnplannVisible')">&#8594; Unplanned Activity Alerts</span></td>
            <td width="800"><b-form-select v-model="model.unplanned_vehicle_activity_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isUnplannVisible">
            <tr>
              <td align="right" width="400">Yard Mile Radius</td>
              <td width="800"><b-form-input v-model="model.unplanned_vehicle_activity_alert_yard_mile_radius" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Vehicle Filter</td>
              <td width="800"><b-form-input v-model="model.unplanned_vehicle_activity_alert_vehicle_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.unplanned_vehicle_activity_alert_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.unplanned_vehicle_activity_alert_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="model.unplanned_vehicle_activity_alert_sms_template">
              <td align="right" width="400">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.unplanned_vehicle_activity_alert_sms_template" :rows="model.unplanned_vehicle_activity_alert_sms_template.length / 20"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-else>
              <td align="right" width="400">SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.unplanned_vehicle_activity_alert_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
          <tr>
            <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isMissingDVIRVisible')">&#8594; Missing DVIR Alerts</span></td>
            <td width="800"><b-form-select v-model="model.missing_dvir_alert_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <template v-if="toggle.isMissingDVIRVisible">
            <tr>
              <td align="right" width="400">Test Mode</td>
              <td width="800"><b-form-select v-model="model.missing_dvir_alert_test_mode" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Send To Driver</td>
              <td width="800"><b-form-select v-model="model.missing_dvir_alert_send_to_driver" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Pre Trip Enabled</td>
              <td width="800"><b-form-select v-model="model.missing_dvir_alert_pre_trip_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Post Trip Enabled</td>
              <td width="800"><b-form-select v-model="model.missing_dvir_alert_post_trip_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Email Recipients</td>
              <td width="800"><b-form-input v-model="model.missing_dvir_alert_email_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">SMS Recipients</td>
              <td width="800"><b-form-input v-model="model.missing_dvir_alert_sms_recipients" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Vehicle Tag Filter</td>
              <td width="800"><b-form-input v-model="model.missing_dvir_alert_vehicle_tag_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Skip Drivers</td>
              <td width="800"><b-form-input v-model="model.missing_dvir_alert_skip_drivers" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Minutes To Look For DVIRS</td>
              <td width="800"><b-form-input v-model="model.missing_dvir_alert_minutes_to_look_for_dvirs" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Pre Trip Minutes After Leaving</td>
              <td width="800"><b-form-input v-model="model.missing_dvir_alert_pre_trip_minutes_after_leaving" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="model.missing_dvir_alert_pre_trip_sms_template">
              <td align="right" width="400">Pre Trip SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.missing_dvir_alert_pre_trip_sms_template" :rows="model.missing_dvir_alert_pre_trip_sms_template.length / 20"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-else>
              <td align="right" width="400">Pre Trip SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.missing_dvir_alert_pre_trip_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr>
              <td align="right" width="400">Post Trip Minutes After Finish</td>
              <td width="800"><b-form-input v-model="model.missing_dvir_alert_post_trip_minutes_after_finish" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="model.missing_dvir_alert_post_trip_sms_template">
              <td align="right" width="400">Post Trip SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.missing_dvir_alert_post_trip_sms_template" :rows="model.missing_dvir_alert_post_trip_sms_template.length / 20"/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-else>
              <td align="right" width="400">Post Trip SMS Template</td>
              <td width="800"><b-form-textarea v-model="model.missing_dvir_alert_post_trip_sms_template" style="field-sizing: content"/></td>
              <td width="250">&nbsp;</td>
            </tr>
          </template>
        </table>

        <hr/>
        <div style="position: relative" class="d-flex align-items-center justify-content-center">
          <b-btn size="lg" type=" submit" variant="success" id=" save-user-submit">Save</b-btn>
          &nbsp;&nbsp;<b-btn size="lg" @click="load_data()">Cancel</b-btn>
        </div>

      </form>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <b-modal title="Manage HOS Alert Configurations" size="huge" v-model="manage_hos_events" ok-only id="hosModal" @ok="hosModalOk($event)">
      <b> Alert Hour is the hour the alert should send. Only 4 alert events are allowed.</b><br/><br/>
      <div v-if="loading">
        <b-spinner style="width: 2rem; height: 1rem;" label="Loading..."></b-spinner>
      </div>
      <div v-else>
        <b-table v-if="this.hos_alert_event_settings" :items="this.hos_alert_event_settings" :fields="['eventName','eventType','hours','limit','days','phone','email','update','remove']">
          <template slot="update" slot-scope="row">
            <b-button size=" sm" @click="update_hos_event(row.item.eventName)">update</b-button>
            <br/>
          </template>
          <template slot="remove" slot-scope="row">
            <b-button size=" sm" @click="delete_hos_event(row.item.eventName)">remove</b-button>
          </template>
        </b-table>
        <hr/>
        <div style="font-weight: bold; font-size: 18px;" v-on:click="toggle_div(toggle,'isHOSAddEventVisible')">&#43; Add Configuration</div><br/>
        <span :style="toggle.isHOSAddEventVisible ? '' : 'display:none'">
            <div><b>
              <!-- <b-form-input v-if="!value || value.length < 100" v-model="model[name]"/> -->
              Event Name: <b-form-input v-model="add_hos_event_model.eventName" required/>
              Event Type: <b-form-select v-model="add_hos_event_model.eventType" :options="hos_event_options" style="width:200px"></b-form-select><br/>
              Alert Hour: <b-form-input v-model="add_hos_event_model.hours" required/>
              On Duty/Driving Total Limit: <b-form-input v-model="add_hos_event_model.limit" required/>
              Number of Days: <b-form-input v-model="add_hos_event_model.days" required/>
              Phone: <b-form-input v-model="add_hos_event_model.phone" />
              Email: <b-form-input v-model="add_hos_event_model.email" />
            </b></div><br/>
            <b-button v-if="!loading" variant="success" size=" sm" @click="add_hos_event()">Save Alert Event</b-button>
          </span>
      </div>
    </b-modal>

    <b-modal title="Manage Vehicle Late Alert Configurations" size="huge" v-model="manage_vehicle_late_events" ok-only id="vehicle_late_alert_modal" @ok="vehicleLateModalOk($event)">
      <b-table v-if="this.vehicle_late_alert_settings" :items="this.vehicle_late_alert_settings" :fields="['eventName','event_types','minutes_threshold','send_to_driver','sms_recipients','email_recipients','update','remove']">
        <template slot="event_types" slot-scope="row">
          <span v-for="(item,idx) in row.item.event_types">
            <span v-if="idx < 2">{{item}}<br/></span>
            <span v-else-if="idx == 2">...</span>
          </span>
        </template>
        <template slot="sms_recipients" slot-scope="row">
          <span v-for="(item,idx) in row.item.sms_recipients.split(',')">
            <span v-if="idx < 2">{{item}}<br/></span>
            <span v-else-if="idx == 2">...</span>
          </span>
        </template>
        <template slot="update" slot-scope="row">
          <b-button size="sm" @click="update_vehicle_late_event(row.item.eventName)">update</b-button>
          <br/>
        </template>
        <template slot="remove" slot-scope="row">
          <b-button size="sm" @click="delete_vehicle_late_event(row.item.eventName)">remove</b-button>
        </template>
      </b-table>
      <hr/>
      <div ref="LateAlertModal" style="font-weight: bold; font-size: 18px;" v-on:click="toggle_div(toggle,'isVehicleLateAddEventVisible')">&#43; Add Configuration</div><br/>
      <span :style="toggle.isVehicleLateAddEventVisible ? '' : 'display:none'">
          <div><b>
            Event Name: <b-form-input v-model="add_vehicle_late_alert_model.eventName" required/>
            <br/>
            Events Types: <b-form-checkbox-group v-model="add_vehicle_late_alert_model.event_types" :options="vehicle_late_alert_options"></b-form-checkbox-group>
            <br/>
            Minutes Threshold: <b-form-input v-model="add_vehicle_late_alert_model.minutes_threshold"></b-form-input>
            Distance Threshold:<b-form-input v-model="add_vehicle_late_alert_model.distance_threshold" :disabled=!isEnabled(add_vehicle_late_alert_model)></b-form-input>
            <span v-if="tenant_type == 'TBN'">
            Use Driver Start Time: <b-form-select v-model="add_vehicle_late_alert_model.driver_start" :options="boolean_options"/>
            Use First Departure Time: <b-form-select v-model="add_vehicle_late_alert_model.departure"  :options="boolean_options"/>
            </span>
            Minutes Before Start Time To Look For Data: <b-form-input v-model="add_vehicle_late_alert_model.minutes_before"></b-form-input>
            Time Window: <b-form-input v-model="add_vehicle_late_alert_model.time_window"></b-form-input>
            SMS Template: <b-form-textarea v-model="add_vehicle_late_alert_model.sms_template" style="field-sizing: content" required/>

            Send To Driver: <b-form-select v-model="add_vehicle_late_alert_model.send_to_driver" :options="boolean_options"/>
            SMS Recipients: <b-form-input v-model="add_vehicle_late_alert_model.sms_recipients" />
            Voice Call Recipients: <b-form-input v-model="add_vehicle_late_alert_model.voice_recipients" />
            Voice Message: <b-form-input v-model="add_vehicle_late_alert_model.voice_message" />
            Email Recipients: <b-form-input v-model="add_vehicle_late_alert_model.email_recipients" />

            <span v-if="tenant_type != 'TBN'">
              Slack URL: <b-form-input v-model="add_vehicle_late_alert_model.slack_url" />
              MS Teams URL: <b-form-input v-model="add_vehicle_late_alert_model.msteams_url" />
            </span>

            <div style="margin:5px; color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'showAdvLateAlertFilters')">&#43; Show Filters</div>
            <div v-if="toggle.showAdvLateAlertFilters" style="margin-left:10px; padding: 10px; border: 1px solid black">
              Contracts Enabled: <b-form-select v-model="add_vehicle_late_alert_model.contracts_enabled" :options="boolean_options"/>
              Charters Enabled: <b-form-select v-model="add_vehicle_late_alert_model.private_hires_enabled" :options="boolean_options"/>
              Driver Name Filter: <b-form-input v-model="add_vehicle_late_alert_model.driver_name_filter" />
              Driver Tag Filter: <b-form-input v-model="add_vehicle_late_alert_model.driver_tag_filter" />
              Vehicle Tag Filter: <b-form-input v-model="add_vehicle_late_alert_model.vehicle_tag_filter" />
              Booking Base Filter: <b-form-input v-model="add_vehicle_late_alert_model.booking_base_filter" />
              Company ID Filter: <b-form-input v-model="add_vehicle_late_alert_model.company_id_filter" />
              Client ID Filter: <b-form-input v-model="add_vehicle_late_alert_model.client_id_filter" />
            </div>
          </b></div><br/>
          <div style="color:red; font-weight:bold;" v-if='this.error_msg !="" '>
            <b>{{this.error_msg}}</b><br/>
          </div>
          <!-- <div>Selected: {{ add_vehicle_late_alert_model.event_types }}</div> -->
          <b-button v-if="!loading" variant="success" size="sm" @click="add_vehicle_late_event()">Save</b-button>
        </span>
    </b-modal>
    
  </div>

</template>
<script>
import {add_hos_event, add_vehicle_late_alert_event, delete_hos_event, delete_vehicle_late_alert_event, get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import {mapState} from "vuex";

export default {
  name: 'tenant_config',
  components: {
  },

  data() {
    return {
      add_hos_event_model: {},
      manage_hos_events: false,
      hos_alert_event_settings: [],
      add_vehicle_late_alert_model: {},
      manage_vehicle_late_events: false,
      vehicle_late_alert_settings: [],
      error_msg: "",
      model: {},
      tenant_json: {},
      toggle: {},
      summary: {},
      loading: true,
      selectedYardOptions: [],
      selectedEventOptions: [],
      yard_options: [],
      objectKeyList: [],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
      hos_event_options: [
        { text: 'Total', value: 'total' },
        { text: 'Driving', value: 'driving' },
        { text: 'On Duty', value: 'onduty' },
      ],
      vehicle_late_alert_options: [],
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    async load_data() {
      this.loading = true
      this.error_msg = ""
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        this.tenant_json = data.summary.tenant

        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              //console.log('found plain object or array: key:'+key+ ' value: '+ setting);
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }

        //clear model when loading (switching tenants isn't clearing the model)
        this.add_vehicle_late_alert_model = {'event_types': []}
        if (this.tenant_type == 'CM') {
          this.vehicle_late_alert_options = [
            {value: 'No Driver HOS Login', text: 'No Driver HOS Login'},
            {value: 'No Driver DVIR', text: 'No Driver DVIR'},
            {value: 'Vehicle Not Started', text: 'Vehicle Not Started'},
            {value: 'Vehicle Not Moved', text: 'Vehicle Not Moved'},
            {value: 'Vehicle Not Left', text: 'Vehicle Not Left'},
            {value: 'Vehicle Not Near Spot', text: 'Vehicle Not Near Spot'},
            {value: 'Vehicle Est Late To Pickup', text: 'Vehicle Est Late To Pickup'},
          ]
        }
        else if (this.tenant_type == 'FASTTRAK') {
          this.vehicle_late_alert_options = [
            {value: 'Vehicle Not Left', text: 'Vehicle Not Left'},
            {value: 'Vehicle Est Late To Pickup', text: 'Vehicle Est Late To Pickup'},
          ]
        } else {
          this.vehicle_late_alert_options = [
          { value: 'No Driver HOS Login', text: 'No Driver HOS Login' },
          { value: 'No TBN Driver Login', text: 'No TBN Driver Login' },
          { value: 'No Driver DVIR', text: 'No Driver DVIR' },
          { value: 'Vehicle Not Started', text: 'Vehicle Not Started' },
          { value: 'Vehicle Not Moved', text: 'Vehicle Not Moved' },
          { value: 'Vehicle Not Left', text: 'Vehicle Not Left' },
          ]
        }

        try {
          if (this.model.driver_hos_alerts_settings != "" && this.model.driver_hos_alerts_settings != null) {
            this.hos_alert_event_settings = JSON.parse(this.model.driver_hos_alerts_settings);
          } else {
            this.hos_alert_event_settings = []
          }
        } catch(e) {
          console.log('exception converting hos alert settings to json:' + e)
        }

        try {
          if (this.model.vehicle_late_alert_settings != null && this.model.vehicle_late_alert_settings != "") {
            this.vehicle_late_alert_settings = JSON.parse(this.model.vehicle_late_alert_settings);
          } else {
            this.vehicle_late_alert_settings = []
          }
        } catch(e) {
          console.log('exception converting vehicle late alert settings to json:', e)
        }

        try {
          if (this.model.late_alert_yards != null && this.model.late_alert_yards != "") {
            this.model.late_alert_yards = JSON.parse(this.model.late_alert_yards)
            this.selectedYardOptions = this.model.late_alert_yards.split(",")
          } else {
            this.selectedYardOptions = []
          }
          if (this.model.vehicle_yards != null && this.model.vehicle_yards != "") {
            this.model.vehicle_yards = JSON.parse(this.model.vehicle_yards);
            let options = []
            for (const item of this.model.vehicle_yards) {
              let yard = { text: item.yard_name, value: item.yard_name }
              options.push(yard)
            }
            this.yard_options = options
          }
        } catch(e) {
          console.log('error setting up vehicle yards for late alerts',e)
        }

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async save_config() {
      try {
        window.scrollTo(0,0);
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        this.setup_yards_to_save()

        //return value to object 
        //console.log("this.objectKeyList: " + JSON.stringify(this.objectKeyList))
        for (const objkey of this.objectKeyList) {
          try {
            let setting = JSON.parse(this.model[objkey])
            this.model[objkey] = setting
          } catch (e) {
            console.log('exception parsing object keys for objkey:' + objkey, e)
          }
        }
        await update_tenant_config_settings(this.user.tenant, this.model)
        this.load_data()

        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    setup_yards_to_save() {
      if (this.selectedYardOptions != null && this.selectedYardOptions != "") {
        this.model.late_alert_yards = this.selectedYardOptions.join()
      } else {
        this.model.late_alert_yards = ""
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item,field,setting) {
      if (!item[field] && setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      } else if (item[field] && !setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    eval_event() {
      const types = this.add_vehicle_late_alert_model.event_types
      this.add_vehicle_late_alert_model.event_types = types
    },
    isEnabled(event) {
      if (event.event_types) {
        return (event.event_types.includes('Vehicle Not Near Spot'))
      } else {
        return false
      }
    },
    async hosModalOk($event) {
      this.add_hos_event_model = {}
      this.update_toggle_div(this.toggle, 'isHOSAddEventVisible', false)
    },
    async add_hos_event() {
      this.loading=true
      //limit number of alerts, update alert if it exists
      if (this.hos_alert_event_settings.length == 4) {
        const alert_event_item = this.hos_alert_event_settings.filter(element => element.eventName == this.add_hos_event_model.eventName)[0]
        if (alert_event_item) {
          this.save_hos_event()
        } else {
          this.cancel_save_hos_event()
        }
      } else {
        this.save_hos_event()
      }
    },
    async save_hos_event() {
      await add_hos_event(this.user.tenant, this.add_hos_event_model)
      this.add_hos_event_model = {}
      this.toggle_div(this.toggle, 'isHOSAddEventVisible')
      await this.load_data()
    },
    async cancel_save_hos_event() {
      this.toggle_div(this.toggle, 'isHOSAddEventVisible')
      this.manage_hos_events = false
      this.add_hos_event_model = {}
      await this.load_data()
    },
    async update_hos_event(event_name) {
      const alert_event_item = this.hos_alert_event_settings.filter(element => element.eventName == event_name)[0]
      if (alert_event_item) {
        this.update_toggle_div(this.toggle, 'isHOSAddEventVisible', true)
        this.add_hos_event_model = alert_event_item
      }
    },
    async delete_hos_event(event_name) {
      this.loading=true
      await delete_hos_event(this.user.tenant, event_name)
      await this.load_data()
    },

    async vehicleLateModalOk($event) {
      this.error_msg = ""
      this.add_vehicle_late_alert_model = {}
      this.update_toggle_div(this.toggle, 'isVehicleLateAddEventVisible', false)
    },
    async add_vehicle_late_event() {
      this.error_msg = ""
      const drv_st = this.add_vehicle_late_alert_model.driver_start != null ? this.add_vehicle_late_alert_model.driver_start.toLowerCase() : null;
      const dep = this.add_vehicle_late_alert_model.departure != null ? this.add_vehicle_late_alert_model.departure.toLowerCase() : null

      //limit number of spot alerts, update alert if it exists?
      // if (this.model.vehicle_late_alert_settings != null && this.model.vehicle_late_alert_settings.length > 0) {
      //   let near_spot_events = this.model.vehicle_late_alert_settings.filter(element => element.event_types.includes('Vehicle Not Near Spot'))
      //   if (near_spot_events != null && near_spot_events.length > 0) {
      //     if (this.add_vehicle_late_alert_model.eventName == near_spot_events[0].eventName) {
      //       //console.log('same name so go ahead and save, name = ' + this.add_vehicle_late_alert_model.eventName)
      //     } else {
      //       this.error_msg = "Only one Alert with the Vehicle Not Near Spot event type is allowed"
      //       this.loading = false
      //       return
      //     }
      //   }
      // }

      if (!this.add_vehicle_late_alert_model.eventName || (this.add_vehicle_late_alert_model.event_types===null || this.add_vehicle_late_alert_model.event_types.length===0) 
        || !this.add_vehicle_late_alert_model.sms_template || 
        (this.tenant_type == 'TBN' 
        && ( ((!drv_st || drv_st===null) && (!dep || dep===null))
        || ( (drv_st === 'True'.toLowerCase() && dep === 'True'.toLowerCase()) 
        || (drv_st ==='False'.toLowerCase() && dep === 'False'.toLowerCase()) ) ))) {
        if (!this.add_vehicle_late_alert_model.eventName) {
          this.error_msg = "Please add an Event Name"
        } 
        if (this.add_vehicle_late_alert_model.event_types === null || this.add_vehicle_late_alert_model.event_types.length===0) {
          this.error_msg = "Please add one or more Event Types"
        } 
        if (!this.add_vehicle_late_alert_model.sms_template) {
          this.error_msg = "Please add a template"
        }
        if (this.tenant_type == 'TBN') {
          if (((!drv_st || drv_st===null)) && ((!dep || dep===null))) {
            this.error_msg = "Please set EITHER Driver Start Time or First Departure Time to True"
          } else if ((drv_st === 'True'.toLowerCase() && dep === 'True'.toLowerCase()) ||
            (drv_st ==='False'.toLowerCase() && dep === 'False'.toLowerCase())) {
            this.error_msg = "Please set EITHER Driver Start Time or First Departure Time to True"
          }
        }
        this.loading = false
        //this.$refs.LateAlertModal.scrollTop = 0
      } else {
        this.loading=true
        this.error_msg = ""
        this.save_vehicle_late_event()
      }
    },
    async save_vehicle_late_event() {
      await add_vehicle_late_alert_event(this.user.tenant, this.add_vehicle_late_alert_model)
      this.add_vehicle_late_alert_model = {}
      this.toggle_div(this.toggle, 'isVehicleLateAddEventVisible')
      await this.load_data()
    },
    async update_vehicle_late_event(event_name) {
      const alert_event_item = this.vehicle_late_alert_settings.filter(element => element.eventName == event_name)[0]
      if (alert_event_item) {
        this.update_toggle_div(this.toggle, 'isVehicleLateAddEventVisible', true)
        this.add_vehicle_late_alert_model = alert_event_item
      }
    },
    async delete_vehicle_late_event(event_name) {
      this.loading=true
      await delete_vehicle_late_alert_event(this.user.tenant, event_name)
      await this.load_data()
    },
    isPlainObject(value,key) {
      //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
    
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    is_admin() {
      return this.user.role === 'admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
</style>

